var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#73AF00"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("rect", {
    y: 202.1,
    style: {
      fill: "#FFE15A"
    },
    width: 512,
    height: 35.93
  }), /*#__PURE__*/React.createElement("rect", {
    y: 238.03,
    style: {
      fill: "#464655"
    },
    width: 512,
    height: 35.93
  }), /*#__PURE__*/React.createElement("rect", {
    y: 273.96,
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 35.93
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.1,
    style: {
      fill: "#FFE15A"
    },
    width: 35.93,
    height: 512
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.03,
    style: {
      fill: "#464655"
    },
    width: 35.93,
    height: 512
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.96,
    style: {
      fill: "#F5F5F5"
    },
    width: 35.93,
    height: 512
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M364.756,171.727c85.917,135.501-57.528,278.945-193.029,193.029  c-9.858-6.251-18.233-14.625-24.484-24.484c-85.916-135.5,57.529-278.945,193.03-193.028  C350.131,153.495,358.505,161.869,364.756,171.727z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M244.432,279.176c0,0-1.573,11.014,9.126,27.378h20.769l-4.72-19.825L244.432,279.176z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A561CD"
    },
    d: "M242.963,205.434c0,0-33.986,55.595,15.944,88.742l5.245-31.469l3.357-40.7l-5.245-17.413  L242.963,205.434z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M242.964,205.433c0,0-3.884,6.467-7.102,16.197c4.374,4.573,16.333,10.238,31.039,7.755l0.609-7.378  l-5.246-17.413L242.964,205.433z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A561CD"
    },
    d: "M236.46,197.462c0,0,0.418-11.119,11.329-11.119c13.637,0,24.756,3.147,42.378,39.651  c0,0-15.674,15.385-25.595-5.874c-2.937-6.294-3.986-13.846-3.986-13.846s-12.168,4.196-20.56-0.629L236.46,197.462z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M241.914,202.707l-2.518-6.713c0,0-14.056-2.308-8.182,14.686c0,0,0.42-3.357,3.986-2.937  S242.544,205.434,241.914,202.707z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M265.411,266.484c0,0-14.789,11.588-6.504,38.812c4.406,14.476,22.028,30.368,22.028,30.368   s13.06-34.144,8.811-47.361C287.247,280.523,265.411,266.484,265.411,266.484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M293.524,310.331c0,0-38.182-36.399-40.7-65.036s13.995-24.09,16.993-22.238   C276.95,227.462,294.992,245.924,293.524,310.331z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B34900"
    },
    d: "M289.752,318.67h-65.149c-0.78,0-1.412-0.632-1.412-1.412v-6.617c0-0.78,0.632-1.412,1.412-1.412  h65.149c0.78,0,1.412,0.632,1.412,1.412v6.617C291.163,318.038,290.531,318.67,289.752,318.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M273.383,309.701c-2.201,0.915-6.608,2.045-5.507,5.979c0.844,3.013,6.608,2.675,5.507,6.136  c-0.745,2.34-12.453,2.556-16.993,1.888c-2.781-0.409-8.811-2.045-7.972-8.969c0.839-6.923,3.357-7.988,6.504-9.231  c3.121-1.233,16.775-0.96,18.776,0.734C274.721,307.105,275.05,309.008,273.383,309.701z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M257.239,135.63l3.067,9.195l9.693,0.075c1.255,0.01,1.775,1.611,0.766,2.357l-7.798,5.758   l2.924,9.242c0.379,1.197-0.984,2.186-2.005,1.457L256,158.077l-7.886,5.637c-1.021,0.73-2.383-0.26-2.005-1.457l2.924-9.242   l-7.798-5.758c-1.01-0.746-0.489-2.347,0.766-2.357l9.693-0.075l3.067-9.195C255.158,134.439,256.842,134.439,257.239,135.63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M257.239,350.614l3.067,9.195l9.693,0.075c1.255,0.01,1.775,1.611,0.766,2.357L262.967,368   l2.924,9.242c0.379,1.197-0.984,2.186-2.005,1.457L256,373.062l-7.886,5.637c-1.021,0.73-2.383-0.26-2.005-1.457l2.924-9.242   l-7.798-5.758c-1.01-0.745-0.489-2.347,0.766-2.357l9.693-0.075l3.067-9.195C255.158,349.424,256.842,349.424,257.239,350.614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M257.239,135.63l3.067,9.195l9.693,0.075c1.255,0.01,1.775,1.611,0.766,2.357l-7.798,5.758   l2.924,9.242c0.379,1.197-0.984,2.186-2.005,1.457L256,158.077l-7.886,5.637c-1.021,0.73-2.383-0.26-2.005-1.457l2.924-9.242   l-7.798-5.758c-1.01-0.746-0.489-2.347,0.766-2.357l9.693-0.075l3.067-9.195C255.158,134.439,256.842,134.439,257.239,135.63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M257.239,350.614l3.067,9.195l9.693,0.075c1.255,0.01,1.775,1.611,0.766,2.357L262.967,368   l2.924,9.242c0.379,1.197-0.984,2.186-2.005,1.457L256,373.062l-7.886,5.637c-1.021,0.73-2.383-0.26-2.005-1.457l2.924-9.242   l-7.798-5.758c-1.01-0.745-0.489-2.347,0.766-2.357l9.693-0.075l3.067-9.195C255.158,349.424,256.842,349.424,257.239,350.614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M182.33,157.692l2.687,9.314l-7.942,5.557c-1.028,0.719-0.549,2.334,0.705,2.376l9.688,0.323   l2.831,9.271c0.366,1.2,2.05,1.243,2.477,0.063l3.301-9.114l9.692,0.173c1.255,0.022,1.816-1.565,0.826-2.336l-7.648-5.956   l3.159-9.164c0.409-1.186-0.928-2.211-1.967-1.507l-8.028,5.433l-7.739-5.836C183.37,155.531,181.983,156.486,182.33,157.692z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M304.206,334.793l2.687,9.314l-7.942,5.557c-1.028,0.719-0.549,2.334,0.705,2.376l9.688,0.323   l2.831,9.271c0.366,1.2,2.05,1.243,2.477,0.063l3.301-9.114l9.692,0.173c1.255,0.022,1.816-1.565,0.826-2.336l-7.648-5.956   l3.159-9.164c0.409-1.186-0.928-2.211-1.967-1.507l-8.028,5.433l-7.739-5.836C305.245,332.632,303.858,333.587,304.206,334.793z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M136.772,219.409l7.74,5.836l-3.016,9.212c-0.39,1.193,0.962,2.196,1.99,1.477l7.942-5.558   l7.829,5.715c1.014,0.74,2.386-0.236,2.019-1.436l-2.831-9.271l7.855-5.68c1.017-0.735,0.513-2.342-0.742-2.364l-9.692-0.172   l-2.975-9.226c-0.385-1.194-2.069-1.211-2.478-0.025l-3.159,9.164l-9.693-0.022C136.307,217.058,135.77,218.654,136.772,219.409z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M340.561,287.884l7.74,5.836l-3.016,9.212c-0.391,1.193,0.962,2.196,1.99,1.477l7.942-5.558   l7.829,5.715c1.014,0.74,2.386-0.236,2.019-1.436l-2.831-9.271l7.855-5.68c1.017-0.735,0.513-2.342-0.742-2.364l-9.692-0.172   l-2.975-9.226c-0.385-1.194-2.069-1.211-2.478-0.025l-3.159,9.164l-9.693-0.022C340.095,285.532,339.559,287.129,340.561,287.884z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M324.551,157.692l-2.687,9.314l7.942,5.557c1.028,0.719,0.549,2.334-0.705,2.376l-9.688,0.323   l-2.831,9.271c-0.366,1.2-2.05,1.243-2.477,0.063l-3.301-9.114l-9.692,0.173c-1.255,0.022-1.816-1.565-0.826-2.336l7.648-5.956   l-3.159-9.164c-0.409-1.186,0.928-2.211,1.967-1.507l8.028,5.433l7.739-5.836C323.512,155.531,324.899,156.486,324.551,157.692z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M202.676,334.793l-2.687,9.314l7.942,5.557c1.028,0.719,0.549,2.334-0.705,2.376l-9.688,0.323   l-2.831,9.271c-0.366,1.2-2.05,1.243-2.477,0.063l-3.301-9.114l-9.692,0.173c-1.255,0.022-1.816-1.565-0.826-2.336l7.648-5.956   L182.9,335.3c-0.409-1.186,0.928-2.211,1.967-1.507l8.028,5.433l7.739-5.836C201.636,332.632,203.024,333.587,202.676,334.793z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M370.109,219.409l-7.74,5.836l3.016,9.212c0.39,1.193-0.962,2.196-1.99,1.477l-7.942-5.558   l-7.829,5.715c-1.014,0.74-2.386-0.236-2.019-1.436l2.831-9.271l-7.855-5.68c-1.017-0.735-0.513-2.342,0.742-2.364l9.692-0.172   l2.975-9.226c0.385-1.194,2.069-1.211,2.478-0.025l3.159,9.164l9.693-0.022C370.575,217.058,371.111,218.654,370.109,219.409z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M166.321,287.884l-7.74,5.836l3.016,9.212c0.39,1.193-0.962,2.196-1.99,1.477l-7.942-5.558   l-7.829,5.715c-1.014,0.74-2.386-0.236-2.019-1.436l2.831-9.271l-7.855-5.68c-1.017-0.735-0.513-2.342,0.742-2.364l9.692-0.172   l2.975-9.226c0.385-1.194,2.069-1.211,2.478-0.025l3.159,9.164l9.693-0.022C166.787,285.532,167.323,287.129,166.321,287.884z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDm);
export default __webpack_public_path__ + "static/media/dm.43234bd3a1f837c377a3b7943596eac4.svg";
export { ForwardRef as ReactComponent };